import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: "Introduction",
      content: `
The terms “We / Us / Our / Company” refer to AICA HEALTH TECH Pvt Ltd and “You / Your / Yourself” refer to users.

This Privacy Policy is governed under the Information Technology Act, 2000. By using our platform, you agree to this policy.
      `,
    },
    {
      title: "User Information",
      content: `
We collect details such as name, email, age, gender, PIN code, medical records, biometric data, and payment information.
      `,
    },
    {
      title: "Cookies",
      content: `
We use cookies to improve user experience and analytics. Cookies do not access personal files.
      `,
    },
    {
      title: "Information Sharing",
      content: `
We do not sell personal data. Information is shared only when required by law or for security purposes.
      `,
    },
    {
      title: "Security",
      content: `
We use encryption and secure servers to protect your data, but no system is 100% secure.
      `,
    },
    {
      title: "Grievance Redressal",
      content: `
Users may contact our Grievance Officer for any issues regarding data or services.
      `,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-cyan-200/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-blue-300/30 rounded-full blur-3xl"></div>

      {/* Main Container */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-10">

        {/* Header */}
        <div className="text-center mb-10">

          <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/80 border border-cyan-200 backdrop-blur-xl text-sm text-cyan-700 shadow-lg">
            AICA HEALTH POLICY
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl font-bold tracking-tight text-slate-800">
            Privacy Policy
          </h1>

          <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Transparent and customer-friendly refund guidelines for all AICA
            subscriptions, services, and healthcare platform operations.
          </p>
        </div>

        {/* Policy Cards */}
        <div className="space-y-6">

          {sections.map((sec, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-3xl border border-white/60 bg-white/70 backdrop-blur-2xl shadow-xl p-6 sm:p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >

              {/* Glass Shine */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent pointer-events-none"></div>

              <div className="relative z-10">
                <h2 className="text-xl sm:text-2xl font-bold mb-4 text-slate-800">
                  {sec.title}
                </h2>

                <p className="text-slate-600 whitespace-pre-line leading-relaxed text-sm sm:text-base">
                  {sec.content}
                </p>
              </div>

            </div>
          ))}

        </div>

        {/* Footer */}
       <div className="mt-10 flex justify-center">
       
                 <button
                   onClick={() => navigate("/")}
                   className="
                   flex items-center gap-2
                   px-6 py-3
                   rounded-2xl
                   bg-gradient-to-r from-cyan-500 to-blue-500
                   text-white
                   font-semibold
                   shadow-lg
                   hover:scale-105
                   hover:shadow-cyan-300/50
                   transition-all duration-300
                 "
                 >
                   <ArrowLeft size={18} />
                   Go Back
                 </button>
                </div>

      </div>
       {/* <AppFooter /> */}
    </div>
  );
};

export default PrivacyPolicy;